(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solfetti-script"] && !Shopify.designMode) return;
  try {
    (function () {
  "use strict";
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : "USD";
  var $ = function (selector, scope) { return (scope || document).querySelector(selector); };
  var $$ = function (selector, scope) { return Array.from((scope || document).querySelectorAll(selector)); };
  var header = $("#siteHeader");
  var progress = $("#scrollProgress");
  var scrim = $("#pageScrim");
  var drawer = $("#cartDrawer");
  var favoritesDrawer = $("#favoritesDrawer");
  var mobileMenu = $("#mobileMenu");
  var searchShell = $("#searchShell");
  var backTop = $("#backTop");
  var toast = $("#toast");
  var toastTimer;
  var favoritesKey = "solfetti:favorites:v1";
  var favorites = readFavorites();

  var policyRte = $(".template-policy .shopify-policy__body .rte");
  if (policyRte && policyRte.dataset.enhanced !== "true") {
    policyRte.dataset.enhanced = "true";
    var policyChildren = Array.from(policyRte.children);
    var firstPolicyHeading = policyChildren.findIndex(function (node) { return node.tagName === "H3"; });
    var policyIntro = document.createElement("div");
    var policyGrid = document.createElement("div");
    policyIntro.className = "sf7-policy-intro reveal";
    policyGrid.className = "sf7-policy-grid";
    policyRte.appendChild(policyIntro);
    policyRte.appendChild(policyGrid);
    policyChildren.slice(0, firstPolicyHeading < 0 ? policyChildren.length : firstPolicyHeading).forEach(function (node) {
      policyIntro.appendChild(node);
    });
    var activePolicyCard = null;
    policyChildren.slice(firstPolicyHeading < 0 ? policyChildren.length : firstPolicyHeading).forEach(function (node) {
      if (node.tagName === "H3") {
        activePolicyCard = document.createElement("section");
        activePolicyCard.className = "sf7-policy-card reveal";
        policyGrid.appendChild(activePolicyCard);
      }
      (activePolicyCard || policyIntro).appendChild(node);
    });
  }

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: currency }).format(Number(cents || 0) / 100);
  }

  function notify(message) {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.add("active");
    toastTimer = setTimeout(function () { toast.classList.remove("active"); }, 2400);
  }

  function readFavorites() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(favoritesKey) || "[]");
      if (!Array.isArray(stored)) return [];
      return stored.filter(function (item) { return item && typeof item.handle === "string" && item.handle; }).slice(0, 50);
    } catch (error) {
      return [];
    }
  }

  function saveFavorites() {
    try { window.localStorage.setItem(favoritesKey, JSON.stringify(favorites)); } catch (error) {}
  }

  function safeFavoriteUrl(value, fallback) {
    try {
      var parsed = new URL(String(value || ""), window.location.origin);
      if (parsed.protocol === "https:" || parsed.protocol === "http:") return parsed.href;
    } catch (error) {}
    return fallback || root + "collections/all";
  }

  function favoriteFromButton(button) {
    return {
      handle: button.dataset.favoriteHandle || "",
      title: button.dataset.favoriteTitle || "",
      url: button.dataset.favoriteUrl || root + "collections/all",
      image: button.dataset.favoriteImage || "",
      price: button.dataset.favoritePrice || ""
    };
  }

  function updateFavoriteButtons() {
    $$('[data-favorite]').forEach(function (button) {
      var active = favorites.some(function (item) { return item.handle === button.dataset.favoriteHandle; });
      button.setAttribute("aria-pressed", String(active));
      button.setAttribute("aria-label", active ? button.dataset.removeLabel : button.dataset.addLabel);
      var copy = $("[data-favorite-copy]", button);
      if (copy) copy.textContent = active ? copy.dataset.removeCopy : copy.dataset.addCopy;
      var action = $("b", button);
      if (action) action.textContent = active ? "−" : "＋";
    });
  }

  function renderFavorites() {
    var count = favorites.length;
    $$(".favorites-count").forEach(function (node) {
      node.textContent = count;
      node.classList.toggle("has-items", count > 0);
    });
    var titleCount = $("#favoritesTitleCount");
    var items = $("#favoritesItems");
    if (titleCount) titleCount.textContent = "(" + count + ")";
    updateFavoriteButtons();
    if (!items || !favoritesDrawer) return;
    items.replaceChildren();
    if (!count) {
      var empty = document.createElement("div");
      empty.className = "favorites-empty";
      var emptyIcon = document.createElement("span");
      emptyIcon.setAttribute("aria-hidden", "true");
      emptyIcon.textContent = "♡";
      var emptyTitle = document.createElement("h3");
      emptyTitle.textContent = favoritesDrawer.dataset.emptyTitle;
      var emptyText = document.createElement("p");
      emptyText.textContent = favoritesDrawer.dataset.emptyText;
      var emptyAction = document.createElement("a");
      emptyAction.className = "text-link";
      emptyAction.href = root + "collections/all";
      emptyAction.textContent = favoritesDrawer.dataset.emptyAction + " →";
      empty.append(emptyIcon, emptyTitle, emptyText, emptyAction);
      items.appendChild(empty);
      return;
    }
    favorites.forEach(function (item, index) {
      var row = document.createElement("article");
      row.className = "favorite-line";
      row.style.setProperty("--favorite-delay", index * 70 + "ms");
      var productUrl = safeFavoriteUrl(item.url, root + "collections/all");
      var media = document.createElement("a");
      media.className = "favorite-media";
      media.href = productUrl;
      if (item.image) {
        var image = document.createElement("img");
        image.src = safeFavoriteUrl(item.image, "");
        image.alt = item.title;
        image.loading = "lazy";
        media.appendChild(image);
      } else {
        var placeholder = document.createElement("span");
        placeholder.className = "favorite-placeholder";
        placeholder.setAttribute("aria-hidden", "true");
        placeholder.textContent = "◇";
        media.appendChild(placeholder);
      }
      var copyWrap = document.createElement("div");
      copyWrap.className = "favorite-copy";
      var title = document.createElement("h3");
      var titleLink = document.createElement("a");
      titleLink.href = productUrl;
      titleLink.textContent = item.title;
      title.appendChild(titleLink);
      var price = document.createElement("p");
      price.textContent = item.price;
      var actions = document.createElement("div");
      actions.className = "favorite-actions";
      var view = document.createElement("a");
      view.href = productUrl;
      view.textContent = favoritesDrawer.dataset.viewLabel + " ↗";
      var remove = document.createElement("button");
      remove.type = "button";
      remove.dataset.removeFavorite = item.handle;
      remove.textContent = favoritesDrawer.dataset.removeLabel;
      actions.append(view, remove);
      copyWrap.append(title, price, actions);
      row.append(media, copyWrap);
      items.appendChild(row);
    });
  }

  function toggleFavorite(button) {
    var item = favoriteFromButton(button);
    if (!item.handle) return;
    var index = favorites.findIndex(function (favorite) { return favorite.handle === item.handle; });
    var adding = index < 0;
    if (adding) favorites.unshift(item);
    else favorites.splice(index, 1);
    saveFavorites();
    renderFavorites();
    button.classList.remove("favorite-pop");
    window.requestAnimationFrame(function () { button.classList.add("favorite-pop"); });
    notify(adding ? favoritesDrawer.dataset.addedMessage : favoritesDrawer.dataset.removedMessage);
  }

  function setLocked() {
    var locked = drawer && drawer.classList.contains("active");
    locked = locked || favoritesDrawer && favoritesDrawer.classList.contains("active");
    locked = locked || mobileMenu && mobileMenu.classList.contains("active");
    locked = locked || searchShell && searchShell.classList.contains("active");
    document.body.classList.toggle("locked", Boolean(locked));
  }

  function closePanels() {
    [drawer, favoritesDrawer, mobileMenu, searchShell].forEach(function (panel) {
      if (!panel) return;
      panel.classList.remove("active");
      panel.setAttribute("aria-hidden", "true");
    });
    if (scrim) scrim.classList.remove("active");
    setLocked();
  }

  function openPanel(panel) {
    closePanels();
    if (!panel) return;
    panel.classList.add("active");
    panel.setAttribute("aria-hidden", "false");
    if (panel === drawer || panel === favoritesDrawer || panel === mobileMenu) scrim.classList.add("active");
    setLocked();
    var close = $(".close-btn", panel);
    if (close) setTimeout(function () { close.focus(); }, 120);
  }

  function renderCart(cart) {
    var count = cart.item_count || 0;
    $$(".bag-count").forEach(function (node) { node.textContent = count; });
    var titleCount = $("#cartTitleCount");
    var subtotal = $("#cartSubtotal");
    var footer = $("#cartFooter");
    var items = $("#cartItems");
    var shippingMessage = $("#shippingMessage");
    var shippingProgress = $("#shippingProgress");
    if (titleCount) titleCount.textContent = "(" + count + ")";
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (footer) footer.hidden = !cart.items.length;
    var shippingStatus = drawer ? $(".shipping", drawer) : null;
    if (shippingMessage && shippingStatus) shippingMessage.textContent = shippingStatus.dataset.freeDeliveryMessage;
    if (shippingProgress) shippingProgress.style.width = "100%";
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<div class="cart-empty"><span style="font-size:34px">◇</span><b>Your bag feels light.</b><span>Beautiful cooling is one step away.</span><a class="text-link" href="' + root + 'collections/all">Explore products <span>→</span></a></div>';
      return;
    }
    items.innerHTML = cart.items.map(function (item, index) {
      var image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image || "";
      var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "Ready to ship";
      return '<div class="cart-line" data-line="' + (index + 1) + '"><img src="' + image + '" alt=""><div><h3><a href="' + item.url + '">' + item.product_title + '</a></h3><small>' + variant + '</small><div class="quantity"><button data-qty="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div><div class="cart-line-end"><button class="remove-item" data-qty="0" aria-label="Remove item">×</button><span>' + money(item.final_line_price) + '</span></div></div>';
    }).join("");
  }

  function refreshCart(openAfter) {
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { renderCart(cart); if (openAfter) openPanel(drawer); return cart; });
  }

  function addVariant(id, button) {
    if (!id) return;
    if (button) button.disabled = true;
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error("Unable to add this selection");
      return refreshCart(true);
    }).then(function () {
      notify("Added to your bag");
    }).catch(function (error) {
      notify(error.message);
    }).finally(function () {
      if (button) button.disabled = false;
    });
  }

  function changeLine(line, quantity) {
    fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(function (response) { return response.json(); }).then(renderCart).catch(function () { notify("The bag could not be updated"); });
  }

  function onScroll() {
    if (header) header.classList.toggle("scrolled", window.scrollY > 20);
    if (backTop) backTop.classList.toggle("visible", window.scrollY > 800);
    if (progress) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.transform = "scaleX(" + (max > 0 ? window.scrollY / max : 0) + ")";
    }
    $$(".parallax-image").forEach(function (image) {
      var rect = image.parentElement.getBoundingClientRect();
      var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -0.045;
      image.style.setProperty("--parallax-y", Math.max(-28, Math.min(28, offset)) + "px");
    });
  }

  window.addEventListener("scroll", function () { window.requestAnimationFrame(onScroll); }, { passive: true });
  onScroll();

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("in-view");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -30px" });
    $$(".reveal,.product-card").forEach(function (node, index) {
      if (node.classList.contains("product-card")) node.style.transitionDelay = index % 3 * 80 + "ms";
      observer.observe(node);
    });
  } else {
    $$(".reveal,.product-card").forEach(function (node) { node.classList.add("in-view"); });
  }

  if (window.matchMedia("(pointer:fine)").matches && !window.matchMedia("(prefers-reduced-motion:reduce)").matches) {
    window.addEventListener("pointermove", function (event) {
      var visual = $("#heroVisual");
      if (!visual) return;
      visual.style.setProperty("--mx", (event.clientX / window.innerWidth - 0.5) * 13 + "px");
      visual.style.setProperty("--my", (event.clientY / window.innerHeight - 0.5) * 10 + "px");
    }, { passive: true });
    $$(".product-media").forEach(function (media) {
      media.addEventListener("pointermove", function (event) {
        var rect = media.getBoundingClientRect();
        media.style.setProperty("--px", (event.clientX - rect.left) / rect.width * 100 + "%");
        media.style.setProperty("--py", (event.clientY - rect.top) / rect.height * 100 + "%");
      });
    });
    $$(".magnetic").forEach(function (button) {
      button.addEventListener("pointermove", function (event) {
        var rect = button.getBoundingClientRect();
        button.style.transform = "translate(" + (event.clientX - rect.left - rect.width / 2) * 0.11 + "px," + (event.clientY - rect.top - rect.height / 2) * 0.16 + "px)";
      });
      button.addEventListener("pointerleave", function () { button.style.transform = ""; });
    });
  }

  var countObserver = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var node = entry.target;
      var target = Number(node.dataset.count);
      var start = performance.now();
      function count(now) {
        var part = Math.min(1, (now - start) / 1250);
        var eased = 1 - Math.pow(1 - part, 3);
        node.textContent = Math.round(target * eased) + (target === 28 ? " dB" : target === 8 ? " hrs" : target === 3 ? "×" : "°");
        if (part < 1) requestAnimationFrame(count);
      }
      requestAnimationFrame(count);
      countObserver.unobserve(node);
    });
  }, { threshold: 0.7 }) : null;
  if (countObserver) $$("[data-count]").forEach(function (node) { countObserver.observe(node); });

  document.addEventListener("click", function (event) {
    var productQuantity = event.target.closest("[data-product-qty]");
    if (productQuantity) {
      var productInput = productQuantity.parentElement.querySelector('input[name="quantity"]');
      if (productInput) productInput.value = Math.max(1, Number(productInput.value || 1) + Number(productQuantity.dataset.productQty));
      return;
    }
    var cartPageQuantity = event.target.closest("[data-cart-page-qty]");
    if (cartPageQuantity) {
      var cartPageInput = cartPageQuantity.parentElement.querySelector('input[name="updates[]"]');
      if (cartPageInput) cartPageInput.value = Math.max(0, Number(cartPageInput.value || 0) + Number(cartPageQuantity.dataset.cartPageQty));
      return;
    }
    var add = event.target.closest("[data-variant-id]");
    if (add) { event.preventDefault(); addVariant(add.dataset.variantId, add); return; }
    var openCart = event.target.closest("[data-open-cart]");
    if (openCart) { event.preventDefault(); refreshCart(true); return; }
    var openFavorites = event.target.closest("[data-open-favorites]");
    if (openFavorites) { event.preventDefault(); renderFavorites(); openPanel(favoritesDrawer); return; }
    if (event.target.closest("[data-close-cart]")) { closePanels(); return; }
    if (event.target.closest("[data-close-favorites]")) { closePanels(); return; }
    var removeFavorite = event.target.closest("[data-remove-favorite]");
    if (removeFavorite) {
      favorites = favorites.filter(function (item) { return item.handle !== removeFavorite.dataset.removeFavorite; });
      saveFavorites();
      renderFavorites();
      notify(favoritesDrawer.dataset.removedMessage);
      return;
    }
    var quantity = event.target.closest("[data-qty]");
    var line = event.target.closest("[data-line]");
    if (quantity && line) { changeLine(line.dataset.line, quantity.dataset.qty); return; }
    var heart = event.target.closest("[data-favorite]");
    if (heart) { event.preventDefault(); toggleFavorite(heart); return; }
    var filter = event.target.closest(".filter");
    if (filter) {
      var value = filter.dataset.filter;
      var visible = 0;
      $$(".filter").forEach(function (item) { item.classList.toggle("active", item === filter); });
      $$(".product-card").forEach(function (card) {
        var show = value === "all" || card.dataset.category === value;
        card.hidden = !show;
        if (show) visible += 1;
      });
      var productCount = $("#productCount");
      if (productCount) productCount.textContent = visible + (visible === 1 ? " product" : " products");
      return;
    }
    var categoryLink = event.target.closest("[data-category-link]");
    if (categoryLink) {
      var targetFilter = $('.filter[data-filter="' + categoryLink.dataset.categoryLink + '"]');
      if (targetFilter) setTimeout(function () { targetFilter.click(); }, 350);
      return;
    }
    var color = event.target.closest(".color-option");
    if (color) {
      $$(".color-option").forEach(function (item) { item.classList.toggle("selected", item === color); });
      var selected = $("#selectedColor");
      if (selected) selected.textContent = color.dataset.color;
    }
  });

  document.addEventListener("change", function (event) {
    var variant = event.target.closest("[data-variant-input]");
    if (!variant) return;
    var price = $("[data-product-price]");
    if (price) {
      price.textContent = variant.dataset.formattedPrice;
      price.animate([{ opacity: .2, transform: "translateY(7px)" }, { opacity: 1, transform: "none" }], { duration: 420, easing: "cubic-bezier(.2,.7,.2,1)" });
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest(".sf7-product-form");
    if (!form) return;
    if (event.submitter && !event.submitter.matches("[data-product-submit]")) return;
    event.preventDefault();
    var button = $("[data-product-submit]", form);
    if (button) { button.disabled = true; button.classList.add("loading"); }
    fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
      .then(function (response) { if (!response.ok) throw new Error("Unable to add this selection"); return refreshCart(true); })
      .then(function () { notify("Added to your bag"); })
      .catch(function (error) { notify(error.message); })
      .finally(function () { if (button) { button.disabled = false; button.classList.remove("loading"); } });
  });

  var menuOpen = $("#menuOpen");
  var menuClose = $("#menuClose");
  var searchOpen = $("#searchOpen");
  var searchClose = $("#searchClose");
  if (menuOpen) menuOpen.addEventListener("click", function () { openPanel(mobileMenu); });
  if (menuClose) menuClose.addEventListener("click", closePanels);
  if (searchOpen) searchOpen.addEventListener("click", function () { openPanel(searchShell); setTimeout(function () { var field = $("#searchField"); if (field) field.focus(); }, 120); });
  if (searchClose) searchClose.addEventListener("click", closePanels);
  if (scrim) scrim.addEventListener("click", closePanels);
  if (searchShell) searchShell.addEventListener("click", function (event) { if (event.target === searchShell) closePanels(); });
  if (backTop) backTop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: "smooth" }); });
  document.addEventListener("keydown", function (event) { if (event.key === "Escape") closePanels(); });

  $$(".accordion-item>button").forEach(function (button) {
    button.addEventListener("click", function () {
      var open = button.getAttribute("aria-expanded") === "true";
      $$(".accordion-item>button").forEach(function (item) { item.setAttribute("aria-expanded", "false"); });
      button.setAttribute("aria-expanded", String(!open));
    });
  });

  var finder = {
    commute: { name: "Solfetti AirHalo Neck Fan", text: "Hands-free, quiet airflow keeps crowded platforms and sunny walks feeling lighter.", url: root + "products/airhalo-neck-fan", image: "https://cdn.shopify.com/s/files/1/0994/7090/1553/files/product-neck-fan.png?v=1788349137" },
    travel: { name: "Solfetti Mini Mist Handheld Fan", text: "Small enough for a side pocket and ready for warm arrival days.", url: root + "products/mini-mist-handheld-fan", image: "https://cdn.shopify.com/s/files/1/0994/7090/1553/files/product-misting-fan.png?v=1788349212" },
    home: { name: "Solfetti Mini Mist Handheld Fan", text: "A soft breeze and fine cooling mist for desks, kitchens and slow afternoons.", url: root + "products/mini-mist-handheld-fan", image: "https://cdn.shopify.com/s/files/1/0994/7090/1553/files/product-misting-fan.png?v=1788349212" },
    outdoors: { name: "Solfetti Wrist Water Bottle", text: "Hydration close at hand for walks, workouts and long open-air weekends.", url: root + "products/wrist-water-bottle", image: "https://cdn.shopify.com/s/files/1/0994/7090/1553/files/product-bottle.png?v=1788349299" }
  };
  $$("[data-find]").forEach(function (button) {
    button.addEventListener("click", function () {
      var result = finder[button.dataset.find];
      var options = $("#finderOptions");
      var resultPanel = $("#finderResult");
      var reset = $("#finderReset");
      if (!result || !resultPanel) return;
      $("#finderImage").src = result.image;
      $("#finderImage").alt = result.name;
      $("#finderName").textContent = result.name;
      $("#finderText").textContent = result.text;
      $("#finderView").href = result.url;
      options.hidden = true;
      resultPanel.classList.add("active");
      reset.hidden = false;
    });
  });
  var finderReset = $("#finderReset");
  if (finderReset) finderReset.addEventListener("click", function () {
    $("#finderOptions").hidden = false;
    $("#finderResult").classList.remove("active");
    finderReset.hidden = true;
  });

  window.addEventListener("storage", function (event) {
    if (event.key !== favoritesKey) return;
    favorites = readFavorites();
    renderFavorites();
  });

  renderFavorites();
  refreshCart(false);
}());
  } catch(e) { console.error(e); }
})();

})();
